class Detail {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-products-detail="scope"]'
		}, config);

		this.$scope = $(this.config.scope);


		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addProductNameToForm();
	}

	addProductNameToForm(){
		$('form input[name="product-20"]').val($('h1.title').text());
	}


}

export default new Detail;
